import React from 'react';
import { FaBox, FaShoppingCart, FaRubleSign, FaClock, FaChartLine, FaExclamationTriangle } from 'react-icons/fa';

function AdminDashboard({ products, orders }) {
  const totalRevenue = orders.reduce((sum, order) => sum + order.totalPrice, 0);
  const newOrders = orders.filter(o => o.status === 'new').length;
  const lowStock = products.filter(p => p.stock < 10).length;
  const todayOrders = orders.filter(o => {
    const orderDate = new Date(o.createdAt);
    const today = new Date();
    return orderDate.toDateString() === today.toDateString();
  }).length;

  const stats = [
    { icon: <FaShoppingCart />, label: 'Всего заказов', value: orders.length, color: '#0d4f3c' },
    { icon: <FaClock />, label: 'Новых заказов', value: newOrders, color: '#ff6b6b' },
    { icon: <FaRubleSign />, label: 'Общая выручка', value: `${totalRevenue}₽`, color: '#d4af37' },
    { icon: <FaBox />, label: 'Товаров', value: products.length, color: '#1a6b4f' },
    { icon: <FaChartLine />, label: 'Заказов сегодня', value: todayOrders, color: '#4a90e2' },
    { icon: <FaExclamationTriangle />, label: 'Мало на складе', value: lowStock, color: '#ee5a24' }
  ];

  const recentOrders = orders.slice(0, 5);

  return (
    <div className="dashboard">
      <h2>Панель управления</h2>
      
      <div className="stats-grid">
        {stats.map((stat, idx) => (
          <div key={idx} className="stat-card" style={{'--stat-color': stat.color}}>
            <div className="stat-icon">{stat.icon}</div>
            <div className="stat-info">
              <div className="stat-value">{stat.value}</div>
              <div className="stat-label">{stat.label}</div>
            </div>
          </div>
        ))}
      </div>

      <div className="dashboard-sections">
        <div className="recent-orders">
          <h3>Последние заказы</h3>
          {recentOrders.length === 0 ? (
            <p className="empty-state">Заказов пока нет</p>
          ) : (
            <div className="orders-list-compact">
              {recentOrders.map(order => (
                <div key={order.id} className="order-compact">
                  <div className="order-compact-info">
                    <strong>{order.customer?.name || 'Без имени'}</strong>
                    <span className="order-date">{new Date(order.createdAt).toLocaleString('ru-RU')}</span>
                  </div>
                  <div className="order-compact-details">
                    <span className={`status-badge status-${order.status}`}>
                      {order.status === 'new' ? 'Новый' : order.status === 'processing' ? 'В работе' : order.status === 'completed' ? 'Завершен' : 'Отменен'}
                    </span>
                    <span className="order-price">{order.totalPrice}₽</span>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        <div className="low-stock-products">
          <h3>Товары с низким остатком</h3>
          {lowStock === 0 ? (
            <p className="empty-state">Все товары в наличии</p>
          ) : (
            <div className="products-list-compact">
              {products.filter(p => p.stock < 10).map(product => (
                <div key={product.id} className="product-compact">
                  <div className="product-compact-info">
                    <strong>{product.name}</strong>
                    <span className="product-category">{product.category}</span>
                  </div>
                  <span className={`stock-badge ${product.stock === 0 ? 'stock-zero' : 'stock-low'}`}>
                    {product.stock} шт.
                  </span>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default AdminDashboard;
